import Enumerator from '../global/Enumerator';

export const contactCompanyTypes = [
  'none',
  'sole_proprietor',
  'pty_ltd',
  'ltd',
  'partnership',
  'trustee_company',
  'individual_trustee',
  'joint_trustee',
  'association',
  'other'
];

export class ContactCompanyType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'sole_proprietor';
        break;
      case '2':
        correctOption = 'partnership';
        break;
      case '3':
        correctOption = 'trustee_company';
        break;
      case '4':
        correctOption = 'association';
        break;
      case '5':
        correctOption = 'pty_ltd';
        break;
      case '6':
        correctOption = 'ltd';
        break;
      case '7':
        correctOption = 'other';
        break;
      case '8':
        correctOption = 'individual_trustee';
        break;
      case '9':
        correctOption = 'joint_trustee';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactCompanyType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  sole_proprietor: {
    get title() {
      return 'Sole proprietor';
    }
  },
  pty_ltd: {
    get title() {
      return 'Pty Ltd';
    }
  },
  ltd: {
    get title() {
      return 'Ltd';
    }
  },
  partnership: {
    get title() {
      return 'Partnership';
    }
  },
  trustee_company: {
    get title() {
      return 'Trustee company';
    }
  },
  individual_trustee: {
    get title() {
      return 'Individual trustee';
    }
  },
  joint_trustee: {
    get title() {
      return 'Joint trustee';
    }
  },
  association: {
    get title() {
      return 'Association';
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  contactCompanyTypes,
  ContactCompanyType
};
